(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
function initializeProductGalleries(scope) {
  scope.querySelectorAll('[data-arpro-gallery]').forEach(function (gallery) {
    if (gallery.dataset.arproGalleryReady === 'true') return;
    var panels = Array.from(gallery.querySelectorAll('[data-arpro-gallery-panel]'));
    var buttons = Array.from(gallery.querySelectorAll('[data-arpro-gallery-target]'));
    if (!panels.length) return;
    var root = gallery.closest('[data-arpro-product]');
    var thumbnails = gallery.querySelector('[data-arpro-gallery-thumbnails]');
    var caption = gallery.querySelector('p[data-arpro-gallery-caption]');

    function selectMedia(id) {
      var selected = panels.find(function (panel) {
        return String(panel.dataset.arproProductMediaId) === String(id);
      }) || panels[0];
      panels.forEach(function (panel) {
        var active = panel === selected;
        if (!active && !panel.hidden) {
          panel.querySelectorAll('video').forEach(function (video) { video.pause(); });
          panel.querySelectorAll('iframe').forEach(function (iframe) {
            var source = iframe.getAttribute('src');
            if (source) iframe.setAttribute('src', source);
          });
        }
        panel.hidden = !active;
      });
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.arproGalleryTarget === selected.dataset.arproProductMediaId));
      });
      if (caption) caption.textContent = selected.dataset.arproGalleryCaption;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () { selectMedia(button.dataset.arproGalleryTarget); });
    });
    function selectVariantMedia() {
      var selector = root && root.querySelector('[data-arpro-variant-select]');
      var option = selector && selector.options[selector.selectedIndex];
      var selected = panels.find(function (panel) { return panel.classList.contains('is-selected-variant-media'); });
      selectMedia(option ? option.dataset.mediaId : selected && selected.dataset.arproProductMediaId);
    }
    if (root) root.addEventListener('arpro:variant:change', selectVariantMedia);
    selectVariantMedia();
    gallery.dataset.arproGalleryReady = 'true';
    if (thumbnails) thumbnails.hidden = false;
    if (caption) caption.hidden = false;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { initializeProductGalleries(document); }, {once: true});
} else {
  initializeProductGalleries(document);
}
document.addEventListener('shopify:section:load', function (event) { initializeProductGalleries(event.target); });


  } catch(e) { console.error(e); }
})();
})();
